import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';
import { IJobState } from './job.reducer';
import { jobFeatureKey, JobPost, JobUpdate } from './types';

const jobFeatureState = createFeatureSelector<IJobState>(jobFeatureKey);

export const jobSelectors = {
  getById: createApiCallSelectors<number, IJobState>(
    jobFeatureState,
    'getById',
  ),
  postJob: createApiCallSelectors<JobPost, IJobState>(
    jobFeatureState,
    'postJob',
  ),
  updateJob: createApiCallSelectors<JobUpdate, IJobState>(
    jobFeatureState,
    'updateJob',
  ),
};
